import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const authApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const authService = {
  login: async (username, password) => {
    const response = await authApi.post('/auth/signin', {
      username,
      password,
    });
    return response.data;
  },

  signup: async (userData) => {
    const response = await authApi.post('/auth/signup', userData);
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  getToken: () => {
    return localStorage.getItem('token');
  },

  getUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  setAuthData: (token, user) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },

  hasRole: (role) => {
    const user = authService.getUser();
    if (!user || !user.roles) return false;
    return user.roles.includes(role);
  },

  hasAnyRole: (roles) => {
    const user = authService.getUser();
    if (!user || !user.roles) return false;
    return roles.some(role => user.roles.includes(role));
  },
};

export default authService;

